<template>
  <div class="settings-tab pa-6">
    <v-card class="settings-card elevation-0">
      <!-- Header -->
      <div class="settings-header pa-4">
        <div class="d-flex align-center">
          <v-icon size="24" class="mr-3" color="primary">mdi-lock-outline</v-icon>
          <span class="settings-section-title">Sigurnost i pristup</span>
        </div>
      </div>

      <v-divider></v-divider>

      <!-- Settings Content -->
      <div class="settings-content pa-6">
        <v-checkbox
          v-model="pinLoginEnabled"
          :loading="loading"
          :disabled="loading || saving"
          @change="savePinLoginSetting"
          class="pin-checkbox"
          color="primary"
          hide-details
        >
          <template v-slot:label>
            <div class="checkbox-label-wrapper">
              <div class="d-flex align-center">
                <v-icon left small color="primary" class="mr-2">mdi-shield-lock</v-icon>
                <span class="checkbox-label">Otvaranje Stolova PIN-om</span>
              </div>
              <div class="checkbox-description mt-1">
                Korisnici moraju unijeti PIN kod za otvaranje stolova
              </div>
            </div>
          </template>
        </v-checkbox>

        <!-- Save indicator -->
        <v-progress-linear
          v-if="saving"
          indeterminate
          color="primary"
          class="mt-3"
        ></v-progress-linear>
      </div>
    </v-card>
  </div>
</template>

<script>
import { df, firebase } from '@/plugins/firebase'

export default {
  name: 'SettingsTab',

  props: {
    locationId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      pinLoginEnabled: false,
      loading: false,
      saving: false
    }
  },

  watch: {
    locationId: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.loadSettings()
        }
      }
    }
  },

  methods: {
    async loadSettings () {
      if (!this.locationId) {
        return
      }

      this.loading = true

      try {
        const docRef = df.doc(`locations/${this.locationId}`)
        const doc = await docRef.get()

        if (doc.exists) {
          const data = doc.data()
          this.pinLoginEnabled = data.orderman && data.orderman.login === 'PIN'
        } else {
          this.pinLoginEnabled = false
        }
      } catch (error) {
        console.error('Error loading settings:', error)
        this.$root.$emit('show-snackbar', {
          text: 'Greška pri učitavanju postavki',
          color: 'error'
        })
      } finally {
        this.loading = false
      }
    },

    async savePinLoginSetting () {
      if (!this.locationId) {
        return
      }

      this.saving = true

      try {
        const docRef = df.doc(`locations/${this.locationId}`)

        if (this.pinLoginEnabled) {
          // Set orderman.login to "PIN"
          await docRef.set({
            orderman: {
              login: 'PIN'
            }
          }, { merge: true })

          this.$root.$emit('show-snackbar', {
            text: 'PIN prijava omogućena',
            color: 'success'
          })
        } else {
          // Remove orderman.login field
          await docRef.update({
            'orderman.login': firebase.firestore.FieldValue.delete()
          })

          this.$root.$emit('show-snackbar', {
            text: 'PIN prijava onemogućena',
            color: 'success'
          })
        }
      } catch (error) {
        console.error('Error saving settings:', error)
        this.$root.$emit('show-snackbar', {
          text: 'Greška pri spremanju postavki',
          color: 'error'
        })

        // Revert the checkbox state on error
        this.pinLoginEnabled = !this.pinLoginEnabled
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.settings-tab {
  max-width: 900px;
  margin: 0 auto;
}

.settings-card {
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(0, 179, 190, 0.15) !important;
  box-shadow: 0 4px 20px rgba(0, 179, 190, 0.08) !important;
  overflow: hidden;
}

.settings-header {
  background: rgba(0, 179, 190, 0.03) !important;
}

.settings-section-title {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #2c3e50 !important;
  letter-spacing: 0.3px !important;
}

.settings-content {
  background: white;
}

.pin-checkbox {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.checkbox-label-wrapper {
  width: 100%;
}

.checkbox-label {
  font-size: 15px !important;
  font-weight: 600 !important;
  color: #2c3e50 !important;
}

.checkbox-description {
  font-size: 13px !important;
  color: #7f8c8d !important;
  line-height: 1.4 !important;
  margin-left: 28px;
}

.pin-checkbox >>> .v-input__slot {
  margin-bottom: 0 !important;
}

.pin-checkbox >>> .v-messages {
  display: none;
}

@media (max-width: 600px) {
  .settings-tab {
    padding: 12px;
  }

  .settings-header {
    padding: 16px;
  }

  .settings-content {
    padding: 20px;
  }

  .settings-section-title {
    font-size: 16px !important;
  }

  .checkbox-label {
    font-size: 14px !important;
  }

  .checkbox-description {
    font-size: 12px !important;
  }
}
</style>
